import { defineComponent as _defineComponent } from 'vue'
import VCheckbox from '@/components/checkmarkbox.vue'
import PaymentButton from '../payment-button.vue'
import { ref, watch, onMounted } from 'vue';
import Loader from '@/components/loader.vue';
import { DataInstance, Meetings, Userspaces, Transactions } from '@busy-human/opt-library';
type Emits = {
    (e: "progress"): void,
    (e: 'update:transaction', transaction: Transactions.Model): void
    (e: "error", arg1:string): void,
}
type Props = {
    meeting: DataInstance<Meetings.Model>
    transaction: DataInstance<Transactions.Model> | null
    user: DataInstance<Userspaces.Model>
    recipient: DataInstance<Userspaces.Model>
}

export default /*#__PURE__*/_defineComponent({
  __name: 'payment-reconfirm',
  props: {
    meeting: null,
    transaction: null,
    user: null,
    recipient: null
  },
  emits: ["progress", "update:transaction", "error"],
  setup(__props: any, { expose, emit }: { emit: ({
    (e: "progress"): void,
    (e: 'update:transaction', transaction: Transactions.Model): void
    (e: "error", arg1:string): void,
}), expose: any, slots: any, attrs: any }) {
  expose();

const props = __props as {
    meeting: DataInstance<Meetings.Model>
    transaction: DataInstance<Transactions.Model> | null
    user: DataInstance<Userspaces.Model>
    recipient: DataInstance<Userspaces.Model>
}

var moment = require('moment'); // require




const userName = ref("")
const recipientName = ref("")
const date = ref("")
const loading = ref(false)
const selectedPaymentId = ref<string | null>(null)
const consentGiven = ref(false)

onMounted(async() => {
    userName.value = props.user.name.fullName
    recipientName.value = props.recipient?.name?.fullName

    date.value = moment(props.meeting.startTime).format("MMMM D")

    selectedPaymentId.value = props?.transaction?.source?.id || null
})


const retryPayment = () => {
    if(!selectedPaymentId.value) return;
    if(!props.transaction) return;
    loading.value = true;

    let source = props.transaction.source
    source.id = selectedPaymentId.value

    emit('update:transaction', { ...props.transaction, source: source, status: Transactions.TransactionStatus.draft } as Transactions.Model);

    emit('progress');
}



const __returned__ = { moment, emit, props, userName, recipientName, date, loading, selectedPaymentId, consentGiven, retryPayment, VCheckbox, PaymentButton, ref, watch, onMounted, Loader, DataInstance, Meetings, Userspaces, Transactions }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})